// extracted by mini-css-extract-plugin
export default {"ListaRestaurantes":"ListaRestaurantes_ListaRestaurantes__c2S2D"};